import React from 'react';
import ColGrip from './ColGrip';

export default function SortableHeader({ label, sortKey, activeKey, dir, onSort, align, className = '' }) {
  const isActive = activeKey === sortKey;
  return (
    <th
      className={`sortable-th${isActive ? ' is-active' : ''} ${className}`.trim()}
      onClick={() => onSort(sortKey)}
      aria-sort={isActive ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
      style={align ? { textAlign: align } : undefined}
    >
      <span className="sortable-th__inner">
        {label}
        <span className="sortable-th__arrow">{isActive ? (dir === 'asc' ? '▲' : '▼') : '⇅'}</span>
      </span>
      <ColGrip />
    </th>
  );
}
